import React from 'react';
import Icon from './AppIcon';
import { SUB_STATUS } from '../hooks/useSubscriptionStatus';

/**
 * SubscriptionBanner
 * Shows an inline amber (reconnecting) or red (failed) banner for subscription errors.
 *
 * @param {{ status: string, subWarningBanner: object, retryNow: function }} props
 */
export default function SubscriptionBanner({ status, subWarningBanner, retryNow }) {
  if (!subWarningBanner?.visible) return null;

  const isError = subWarningBanner?.type === 'error';

  return (
    <div
      className={`flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm mb-4 ${
        isError
          ? 'bg-red-50 border border-red-200 text-red-700' :'bg-amber-50 border border-amber-200 text-amber-700'
      }`}
      style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}
    >
      <Icon
        name={isError ? 'WifiOff' : 'Wifi'}
        size={15}
        color="currentColor"
        className={!isError ? 'animate-pulse' : ''}
      />
      <span className="flex-1">{subWarningBanner?.message}</span>
      {(isError || status === SUB_STATUS?.ERROR) && (
        <button
          onClick={retryNow}
          className={`flex items-center gap-1.5 text-xs font-semibold px-3 py-1 rounded-md transition-colors ${
            isError
              ? 'bg-red-100 hover:bg-red-200 text-red-700' :'bg-amber-100 hover:bg-amber-200 text-amber-700'
          }`}
        >
          <Icon name="RefreshCw" size={12} color="currentColor" />
          Reintentar
        </button>
      )}
      {!isError && status !== SUB_STATUS?.ERROR && (
        <Icon name="Loader2" size={14} color="currentColor" className="animate-spin" />
      )}
    </div>
  );
}
